module.exports = { "default": require("core-js/library/fn/is-iterable"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ../node_modules/babel-runtime/core-js/is-iterable.js
// module id = 695
// module chunks = 0